import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../Card';
import { Badge } from '../Badge';
import { ShareBreakdown } from './ShareBreakdown';
import type { BucketRow, RegionTraffic } from '../../types/traffic';
interface GeographyBreakdownsProps {
  countries: BucketRow[];
  cities: BucketRow[];
  regions: RegionTraffic[];
}
function toRows(rows: BucketRow[]) {
  return rows.map(row => ({
    label: row.label,
    share: row.share,
    detail: (row.visitors ?? row.requests).toLocaleString()
  }));
}
export function GeographyBreakdowns({
  countries,
  cities,
  regions
}: GeographyBreakdownsProps) {
  const hasEdgeGeo = countries.length > 0 || cities.length > 0;
  return <section aria-label="Geography" className="grid gap-4 sm:gap-6 lg:grid-cols-3" data-id="element-68" data-mp="2qoja1pb482fp">
      <Card data-id="element-69" data-mp="2lookpq6znkwr">
        <CardHeader data-id="element-70" data-mp="2lp6emg66hn1i">
          <CardTitle data-id="element-71" data-mp="2lnmyqqofpe09">Countries</CardTitle>
          <CardDescription data-id="element-72" data-mp="2lqr8s4okz3yu">Affected visitors by country, resolved at the edge</CardDescription>
        </CardHeader>
        <CardContent data-id="element-73" data-mp="3csrljc1w07od">
          {countries.length ? <ShareBreakdown rows={toRows(countries)} data-id="element-74" data-mp="3cr6ptj3u6iox" /> : <p className="py-6 text-center font-mono text-xs text-muted-foreground" data-id="element-75" data-mp="3hk9lbws6c27r">
              No country data — see the edge setup note below
            </p>}
        </CardContent>
      </Card>

      <Card data-id="element-76" data-mp="37u6jr86zlfxt">
        <CardHeader data-id="element-77" data-mp="37ty3d6bnnshv">
          <CardTitle data-id="element-78" data-mp="37rbvf5kuraz4">Cities</CardTitle>
          <CardDescription data-id="element-79" data-mp="3vihb9kqsm39f">Metro-level only, and approximate</CardDescription>
        </CardHeader>
        <CardContent data-id="element-80" data-mp="4d7sad17up9b">
          {cities.length ? <ShareBreakdown rows={toRows(cities)} data-id="element-81" data-mp="4alngl5pmnus" /> : <div className="py-4 text-xs leading-relaxed text-muted-foreground" data-id="element-82" data-mp="3mhj6v1cfztqb">
              <p className="font-medium text-foreground" data-id="element-83" data-mp="3qj4r57rb3aaj">No city data yet</p>
              <p className="mt-1.5" data-id="element-84" data-mp="2b3e1q50htdte">
                City needs one of two things — an{' '}
                <span className="font-mono" data-id="element-85" data-mp="2f4r8qifbnn1w">x-geo-city</span> meta tag injected by the edge
                (preferred), or an IP-geo provider set in{' '}
                <span className="font-mono" data-id="element-86" data-mp="llh6i6awodkh">data/geoConfig.ts</span>.
              </p>
            </div>}
        </CardContent>
      </Card>

      <Card data-id="element-87" data-mp="bvxmgxbgido1">
        <CardHeader data-id="element-88" data-mp="bvp62vg4kq83">
          <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-89" data-mp="bv5s1ptlilzc">
            <CardTitle data-id="element-90" data-mp="6xnnebmm2sx5">Time zones</CardTitle>
            {!hasEdgeGeo && <Badge variant="outline" data-id="element-91" data-mp="6v9wmeyys2ve">Fallback</Badge>}
          </div>
          <CardDescription data-id="element-92" data-mp="2x3tdgxc45f8">Reported by the browser, no lookup involved</CardDescription>
        </CardHeader>
        <CardContent data-id="element-93" data-mp="3u0ipv5vzrj95">
          {regions.length ? <ShareBreakdown rows={regions.map(region => ({
          label: region.region,
          share: region.share,
          detail: region.requests.toLocaleString()
        }))} data-id="element-94" data-mp="3p27gsxditcrz" /> : <p className="py-6 text-center font-mono text-xs text-muted-foreground" data-id="element-95" data-mp="1n99tti6fdeey">No data yet</p>}
        </CardContent>
      </Card>
    </section>;
}